import { render } from "./BaseResizableTripleColumns.vue?vue&type=template&id=5a8d4176&scoped=true"
import script from "./BaseResizableTripleColumns.vue?vue&type=script&lang=js"
export * from "./BaseResizableTripleColumns.vue?vue&type=script&lang=js"

import "./BaseResizableTripleColumns.vue?vue&type=style&index=0&id=5a8d4176&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a8d4176"]])

export default __exports__